import moment, { Moment } from 'moment';
import { DATE_FORMAT, DATE_TIME_FORMAT, TIME_FORMAT } from '@/config';
import { getTimeByUtcOffset } from './intl';

export type DateType = moment.Moment;

export type DateSourceType = moment.MomentInput;

// const format2Str: (date: DateSourceType, format: string) => string = (date, format) => {
//   return moment(date || undefined).format(format);
// };

export const format2DateStr: (date?: DateSourceType) => string = (date) => {
  return getTimeByUtcOffset(date, DATE_FORMAT) as string;
};

export const format2TimeStr: (date?: DateSourceType) => string = (date) => {
  return getTimeByUtcOffset(date, TIME_FORMAT) as string;
};

export const format2FullTimeStr: (date?: DateSourceType) => string = (date) => {
  return getTimeByUtcOffset(date, DATE_TIME_FORMAT) as string;
};

export const format2TimeStamp: (date?: DateSourceType) => number = (date) => {
  return getTimeByUtcOffset(date || undefined).valueOf() as number;
};

// 秒转换为时分秒
export const parseSeconds2Hour: (seconds: number) => string = (seconds) => {
  if (typeof seconds !== 'number' || seconds < 0) return '';
  const hourValue = Math.floor(seconds / 3600); // 小时 60分*60秒
  const minuteValue = Math.floor((seconds - 3600 * hourValue) / 60); // 分 60秒
  const secondValue = seconds % 60; // 秒
  return [hourValue, minuteValue, secondValue]
    .map((val) => `${val < 10 ? '0' : ''}${val}`)
    .join(':');
};

export default moment;
